import { apiRequest } from './adminApi';
import { formatDateOnly } from './formatters';
import { BUSINESS_TIMEZONE } from './timezone';

const BASE = '/client-prices';
const token = () => localStorage.getItem('token') || sessionStorage.getItem('token');
const formPost = async (url, form) => {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${url}`, { method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: form });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `Request failed (${res.status})`);
  return data;
};

export const getClientPriceConfig = () => apiRequest(`${BASE}/config`);
export const getClientPriceRows = (clientId) => apiRequest(`${BASE}/client/${clientId}`);
export const checkClientPrice = (body) => apiRequest(`${BASE}/check`, { method: 'POST', body: JSON.stringify(body) });
export const createClientPrice = (body) => apiRequest('/pricing-rules', { method: 'POST', body: JSON.stringify(body) });
export const updateClientPrice = (ruleId, body) => apiRequest(`/pricing-rules/${ruleId}`, { method: 'PATCH', body: JSON.stringify(body) });
export const updateLegacyPrice = (legacyId, body) => apiRequest(`/pricing/${legacyId}`, { method: 'PATCH', body: JSON.stringify(body) });
export const deactivateLegacyPrice = (legacyId) => apiRequest(`/pricing/${legacyId}`, { method: 'DELETE' });
export const getConvertPreview = (legacyId) => apiRequest(`${BASE}/legacy/${legacyId}/convert/preview`);
export const convertLegacy = (legacyId) => apiRequest(`${BASE}/legacy/${legacyId}/convert`, { method: 'POST' });
export const copyClientPrices = (body) => apiRequest(`${BASE}/copy`, { method: 'POST', body: JSON.stringify(body) });
export const listConversions = (clientId) => apiRequest(`${BASE}/conversions${clientId ? `?client_code_id=${clientId}` : ''}`);
export const revertConversion = (id, reason) => { const f = new FormData(); f.append('reason', reason); return formPost(`${BASE}/conversions/${id}/revert`, f); };
export const validateClientPriceImport = (file) => { const f = new FormData(); f.append('file', file); return formPost(`${BASE}/import/validate`, f); };
export const commitClientPriceImport = (id, { supersede = false, skipInvalid = false } = {}) => { const f = new FormData(); f.append('supersede', supersede ? 'true' : 'false'); f.append('skip_invalid', skipInvalid ? 'true' : 'false'); return formPost(`${BASE}/import-batches/${id}/commit`, f); };
export const rollbackClientPriceImport = (id, reason) => { const f = new FormData(); f.append('reason', reason); return formPost(`${BASE}/import-batches/${id}/rollback`, f); };
export const listClientPriceBatches = () => apiRequest(`${BASE}/import-batches`);
export const getDataObservations = () => apiRequest(`${BASE}/data-observations`);
export const templateUrl = () => `${process.env.REACT_APP_BACKEND_URL}/api${BASE}/import/template`;
export const downloadTemplate = async () => {
  const res = await fetch(templateUrl(), { headers: { Authorization: `Bearer ${token()}` } });
  if (!res.ok) throw new Error('Template download failed');
  const blob = await res.blob();
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'client_selling_prices_template.csv'; a.click(); URL.revokeObjectURL(a.href);
};

export const METHOD_LABEL = { online_nationwide: 'Online / Nationwide', ground_abstractor: 'Ground Abstractor' };
export const methodLabel = (m, category) => (category === 'TITLE_SEARCH' ? (METHOD_LABEL[m] || 'Any Method') : '—');
export const appliesTo = (r) => (r.state && r.county ? `${r.state} / ${r.county}` : r.state || 'All States');
// CLIENT-PRICE-EDIT-METHOD-001: stored effective dates are business-day bounds in UTC (end of day ET = next
// day 04:59Z) — derive the calendar date in the business timezone, never from a UTC slice.
export const businessDateOnly = (d) => {
  if (!d) return '';
  const s = String(d);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const t = new Date(s);
  if (Number.isNaN(t.getTime())) return s.slice(0, 10);
  return new Intl.DateTimeFormat('en-CA', { timeZone: BUSINESS_TIMEZONE, year: 'numeric', month: '2-digit', day: '2-digit' }).format(t);
};
export const fmtDate = (d) => (d ? formatDateOnly(businessDateOnly(d)) : '');
export const money = (v) => `$${Number(v || 0).toFixed(2)}`;
